import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  const getTrendIcon = (trend: string, change: string) => {
    if (trend === 'up') return <i className="ri-arrow-up-line text-secondary-600 text-sm"></i>;
    if (trend === 'down') return <i className="ri-arrow-down-line text-primary-500 text-sm"></i>;
    return <i className="ri-subtract-line text-foreground-400 text-sm"></i>;
  };

  const getTrendColor = (trend: string) => {
    if (trend === 'up') return 'text-secondary-600';
    if (trend === 'down') return 'text-primary-500';
    return 'text-foreground-400';
  };

  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            热门排行
          </h2>
          <p className="text-sm text-foreground-500">实时热度排行，看看哪部漫画最受欢迎</p>
        </div>
        <div className="max-w-3xl mx-auto">
          {rankingData.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 p-4 hover:bg-background-100 rounded-lg transition-colors border-b border-background-200/50 last:border-0 cursor-pointer group"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-foreground-900 text-sm truncate group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </span>
                  <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-secondary-100 text-secondary-700 shrink-0">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className={`text-xs font-medium flex items-center gap-0.5 ${getTrendColor(item.trend)}`}>
                  {getTrendIcon(item.trend, item.change)}
                  {item.change}
                </span>
              </div>
              <div className="text-sm font-semibold text-foreground-700 shrink-0 w-20 text-right">
                {item.heat}
                <span className="text-xs text-foreground-500 font-normal ml-0.5">热度</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}